(function () {
    angular.module('tradersyard').directive('samplingForm', samplingFormDirective);

    samplingFormDirective.$inject = [
        '$parse',
        '$rootScope',
        'RequestManagerFactory',
        'InviteManagerFactory',
        'graph-invite-factory',
        '$compile',
        '$timeout',
        'GuidFactory',
        '$window',
    ];

    function samplingFormDirective(
        $parse,
        $root,
        RequestManagerFactory,
        InviteManagerFactory,
        $invite,
        $compile,
        $timeout,
        GuidFactory,
        $window
    ) {
        return {
            restrict: 'A',
            scope: true,
            link: link,
        };

        function link($scope, $element, $attr) {
            var acceptBtn = angular.element($element[0].querySelector('[sampling-form-accept]')),
                rejectBtn = angular.element($element[0].querySelector('[sampling-form-reject]')),
                nodeId = 0,
                notification = false,
                Guid = GuidFactory.Generate();

            function parseValue(attr) {
                return $parse(attr)($scope);
            }

            $timeout(function () {
                nodeId = parseValue($attr.nodeId);
                notification = parseValue($attr.notification) === true;
            });

            var Manager;

            switch ($attr.samplingType) {
                case 'invite':
                    Manager = InviteManagerFactory.Init(parseValue($attr.entryId), parseValue($attr.entry), $scope);
                    break;
                default:
                    Manager = RequestManagerFactory.Init(parseValue($attr.entryId), parseValue($attr.entry), $scope);
                    break;
            }

            acceptBtn.bind('click', function () {
                nodeId = parseValue($attr.nodeId);

                if (!nodeId) return;

                Manager.Accept(nodeId, Guid, function () {
                    $root.$broadcast('invitation-accept');
                    finish('accept');
                });
            });

            rejectBtn.bind('click', function () {
                nodeId = parseValue($attr.nodeId);

                if (!nodeId) return;

                Manager.Reject(nodeId, Guid, function () {
                    finish('reject');
                });
            });

            function applyOrEvalIfSet(attr) {
                if (!attr) return;

                var phase = $scope.$parent.$$phase;

                if (phase === '$apply' || phase === '$digest') {
                    $scope.$parent.$eval(attr);
                } else {
                    $scope.$parent.$apply(attr);
                }
            }

            function finish(state) {
                applyOrEvalIfSet($attr.after);

                var message = '';

                switch (state) {
                    case 'accept':
                        applyOrEvalIfSet($attr.accept);
                        message = 'accepted';
                        break;
                    case 'reject':
                        applyOrEvalIfSet($attr.reject);
                        message = 'rejected';
                        break;
                }

                if (notification === false) return;

                $element[0].outerHTML = '<span>' + message + '</span>';
                $compile($element.contents())($scope);
            }
        }
    }
})();
